import React from "react";
import { CHUIProgressBackdrop } from "@connecthealth-ui/core";

export function CancelAppointmentWaiting(props) {
  return <CHUIProgressBackdrop color="secondary" />;
}
